export const EnterpriseReportConstants = {
    GET_ALL_ENTERPRISE_REPORT_SUCCESS: "GET_ALL_ENTERPRISE_REPORT_SUCCESS",
    GET_ALL_ENTERPRISE_REPORT_ERROR: "GET_ALL_ENTERPRISE_REPORT_ERROR",
    ALL_ENTERPRISE_REPORT_LOADING: "ALL_ENTERPRISE_REPORT_LOADING",
    EMPTY_ENTERPRISE_REPORT: "EMPTY_ENTERPRISE_REPORT",
};